export default "__VITE_ASSET__Cg1ku0KQ__"